import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { type Comedian, getComedians } from "../legacy/comedian";

/**
 * Fetch the full comedian list, optionally including unverified comedians.
 * Cached for 5 minutes — the list changes rarely and several surfaces
 * (switchers, selectors) share it.
 */
export function useAllComedians(
  includeUnverified = false
): UseQueryResult<Comedian[], Error> {
  return useQuery({
    queryKey: ["allComedians", includeUnverified] as const,
    queryFn: () => getComedians(includeUnverified),
    staleTime: 5 * 60 * 1000,
  });
}
